export const INPUT_TYPES = {
  TEXT: "TEXT",
  EMAIL: "EMAIL",
  NUMBER: "NUMBER",
  CURRENCY: "CURRENCY",
  PASSWORD: "PASSWORD",
  PHONE_NUMBER: "PHONE_NUMBER",
  MULTI_LINE_TEXT: "MULTI_LINE_TEXT",
  DATE: "DATE",
} as const;

export const INPUT_TYPE_TO_WIDGET_TYPE_MAP = {
  [INPUT_TYPES.TEXT]: "WDS_INPUT_WIDGET",
  [INPUT_TYPES.EMAIL]: "WDS_EMAIL_INPUT_WIDGET",
  [INPUT_TYPES.NUMBER]: "WDS_NUMBER_INPUT_WIDGET",
  [INPUT_TYPES.PASSWORD]: "WDS_PASSWORD_INPUT_WIDGET",
  [INPUT_TYPES.MULTI_LINE_TEXT]: "WDS_MULTILINE_INPUT_WIDGET",
  [INPUT_TYPES.CURRENCY]: "WDS_CURRENCY_INPUT_WIDGET",
  [INPUT_TYPES.PHONE_NUMBER]: "WDS_PHONE_INPUT_WIDGET",
  [INPUT_TYPES.DATE]: "WDS_DATEPICKER_WIDGET",
};
